import React from 'react';
import { useParams } from 'react-router-dom';
import FormDataDetails from './FormDataDetails';
import { withAuth } from '../auth/withAuth';

const FormData = () => {
  const { assignmentId } = useParams();
  return <FormDataDetails assignmentId={assignmentId} />;
};

// Only apply withAuth, not withCopyPasteProtection
const FormDataWithAuth = withAuth(FormData);

export default FormDataWithAuth; 